import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import AppContext from '@/common/context/app.context'

const useCustomLogisticsLabel = () => {
  const { info } = useContext(AppContext)
  const { i18n } = useTranslation()

  const customMessage = info?.selectedStore?.preferences?.custom_messages?.[i18n.language]
  const logisticsFeeLabel = customMessage?.find(message => message.key === 'logistics_fee.label')

  return logisticsFeeLabel?.message
}

export default useCustomLogisticsLabel
